// Angular build information, automatically generated by `angular-build-info`
export const buildInfo = {
    hash: "8b767160",
    user: "ctiaserver",
    version: "0.1.34",
    timestamp: "February 24, 2026 09:07:56"
};
